export const localization = {
  pt: {
    locale: 'pt-BR',
    header: {
      title: 'Tokens de IA',
      description: 'Acompanhe o uso dos Tokens de IA da sua operação conversacional.',
      learnMore: 'Saiba mais sobre o token.',
      modalContent: {
        title: 'Detalhamento dos termos de consumo',
        token: {
          title: 'Token',
          description:'Quaisquer mensagens por disparo ativo enviadas pela empresa, independentemente do engajamento (interação ou resposta) do usuário final.',
        },
        action: 'Fechar',
      },
      showMoreButton: 'Ver mais',
      pathname: '/ai-tokens-consumption',
    },
    chart: {
      title: 'Consumo diário',
      aiToken: 'Tokens de IA',
    },
    infoPaper: {
      headerTitle: 'Consumo atual',
      aiToken: 'Volume de tokens',
    },
  },
  en: {
    locale: 'en-US',
    header: {
      title: 'AI Tokens',
      description: 'Track the usage of AI Tokens in your conversational operation.',
      learnMore: 'Learn more about the token.',
      modalContent: {
        title: 'Detailed terms of usage',
        token: {
          title: 'Token',
          description:'Any proactively triggered messages sent by the company, regardless of whether the end-user engages (interacts or responds).',
        },
        action: 'Close',
      },
      showMoreButton: 'See more',
      pathname: '/ai-tokens-consumption',
    },
    chart: {
      title: 'Daily consumption',
      aiToken: 'AI Tokens',
    },
    infoPaper: {
      headerTitle: 'Current usage',
      aiToken: 'Token volume',
    },
  },
  es: {
    locale: 'es-ES',
    header: {
      title: 'Tokens de IA',
      description: 'Monitorea el uso de los Tokens de IA en tu operación conversacional.',
      learnMore: 'Obtenga más información sobre el token.',
      modalContent: {
        title: 'Detalle de los términos de consumo',
        token: {
          title: 'Token',
          description:'Cualquier mensaje activado proactivamente enviado por la empresa, independientemente de la participación del usuario final (interacción o respuesta).',
        },
        action: 'Cerrar',
      },
      showMoreButton: 'Ver más',
      pathname: '/ai-tokens-consumption',
    },
    chart: {
      title: 'Consumo diario',
      aiToken: 'Tokens de IA',
    },
    infoPaper: {
      headerTitle: 'Consumo actual',
      aiToken: 'Volumen de tokens',
    },
  },
};
